import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      <img src={"./pika.gif"} alt="pokemon-gif" />
      <h1 className="title">POKEDEX</h1>
      <img src="./ball.png" alt="pikachu" />
    </div>
  );
};

export default Logo;
